import fetch from '../utils/fetch-json';

import { FAILED_TO_GET_EXPLORE, FETCHING_EXPLORE, GOT_EXPLORE } from './project-explore-reducer';

export const fetchExplore =
    (filters) =>
    ({ dispatch, getState }) => {
        const state = getState();
        let fullUrl;
        if (filters.type === 'geography') {
            fullUrl = state.baseURL.concat(`/api/public/project/explore?geography=${filters.geography}`);
        } else {
            fullUrl = state.baseURL.concat(`/api/public/project/loved`);
        }
        dispatch({ type: FETCHING_EXPLORE });

        return fetch({ url: fullUrl, dispatch, getState })
            .then((response) => {
                const projectIds = response.body.projectIds;
                dispatch({
                    type: GOT_EXPLORE,
                    data: { allIdsForFilters: projectIds },
                });
            })
            .catch((error) =>
                dispatch({
                    type: FAILED_TO_GET_EXPLORE,
                    data: error.body,
                })
            );
    };

export const fetchExploreBank =
    (bankId) =>
    ({ dispatch, getState }) => {
        const state = getState();
        const fullUrl = state.baseURL.concat(`/api/public/project/bank/explore/${bankId}`);
        dispatch({ type: FETCHING_EXPLORE });

        return fetch({ url: fullUrl, dispatch, getState })
            .then((response) => {
                const projectIds = response.body.projectIds;

                dispatch({
                    type: GOT_EXPLORE,
                    data: { allIdsForFilters: projectIds },
                });
            })
            .catch((error) =>
                dispatch({
                    type: FAILED_TO_GET_EXPLORE,
                    data: error.body,
                })
            );
    };
